import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/files/constants';
import { filesQueryKeys } from '@/modules/files/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

export const useUploadFilesMutation = () => {
  return useMutation({
    mutationFn: async (files: File[]) => {
      if (files.length === 0) {
        return [];
      }

      const { data } = await fetchClient.POST(endpoints.files, {
        body: {
          // pass an empty array to trigger body serializer
          request: [],
        },
        bodySerializer: () => {
          const formData = new FormData();
          files.forEach((file) => {
            formData.append('request', file);
          });

          return formData;
        },
      });

      return data;
    },
    onSettled: () => {
      invalidateQuery(filesQueryKeys.list())();
    },
  });
};
